// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kKuX","content":"styles_content__1Zvm1","tableWrap":"styles_tableWrap__14uEA"};